/**
 * SLA Configuration by Classification
 * SLA values are in business days (días hábiles)
 */

export const SLA_BY_CLASSIFICATION = {
  "v-162888": { label: "Acoso moral / laboral", sla: 60 },
  "v-162899": { label: "Conducta Inadecuada", sla: 15 },
  "v-162891": { label: "Acoso sexual", sla: 60 },
  "v-112418": { label: "Discriminación", sla: 60 },
  "v-162900": { label: "Agresión física o amenaza", sla: 30 },
  "v-162898": { label: "Represalia", sla: 60 },
  "v-162901": { label: "Irregularidades relacionadas con encuestas ENG y EXE", sla: 75 },
  "v-162902": { label: "Alcohol, Drogas y Armas", sla: 30 },
  "v-162893": { label: "Conflictos de interés", sla: 75 },
  "v-165439": { label: "Actividad laboral externa", sla: 75 },
  "v-167065": { label: "Violación de términos y condiciones de plataformas", sla: 90 },
  "v-162895": { label: "Lavado de dinero y financiamiento del terrorismo", sla: 60 },
  "v-162896": { label: "Soborno", sla: 60 },
  "v-165497": { label: "Libros y registros contables", sla: 60 },
  "v-165445": { label: "Información confidencial", sla: 60 },
  "v-167063": { label: "Incumplimiento de leyes, regulaciones y politicas internas", sla: 90 },
  "v-165448": { label: "Bienes y recursos", sla: 15 },
  "v-167064": { label: "Sistemas y herramientas tecnológicas", sla: 75 },
  "v-165449": { label: "Fraude interno", sla: 90 },
};

/**
 * Get SLA days for a given classification value
 * @param {string|object} classification - The classification value (e.g., "v-162888") or object with value property
 * @returns {number|null} - SLA in business days or null if not found
 */
export const getSLAByClassification = (classification) => {
  if (!classification) return null;

  // Extract value from object if needed
  const value = typeof classification === "object"
    ? classification.value
    : classification;

  if (!value) return null;

  const config = SLA_BY_CLASSIFICATION[value];
  return config ? config.sla : null;
};

/**
 * Default SLA if classification is not found
 */
export const DEFAULT_SLA = 30;
